<template>
  <div>
    <div
      style="background-color: #045AB2;width: 100%;height: 45px;position: relative;"
    >
      <div
        style="display: flex;width: 137px;position: absolute;left: 50%;margin-left: -68.5px;"
      >
        <img
          src="../assets/img/jiulogo.png"
          style="width: 23px;height: 33px;margin:auto"
        />
        <div
          style="color: #ffffff;font-size: 15px;line-height: 45px;width: 100px;"
        >
          房县黄酒网
        </div>
      </div>
    </div>
    <div style="background-color: #E7F0FC">
      <div
        style="display: flex;padding: 30px 40px 30px 61px"
        class="main-width"
      >
        <div style="color: #045AB2;margin-right: 72px;">
          <div style="font-size: 23px;font-weight: 500;">湖北·十堰</div>
          <div style="color: #8D9095;margin-top: 13px;margin-bottom: 6px;">
            网站点击次数统计
          </div>
          <div style="font-size: 17px;">
            {{accessNum}}<span
              style="font-size: 17px;color: #8D9095;margin-left: 5px;"
              >次</span
            >
          </div>
        </div>
        <div
          style="color: #626262;font-weight: 400;line-height: 30px;margin-right: 60px"
        >
          <div>地址：房县城关镇武当路35号</div>
          <div>电话：0719-3233689</div>
          <div>邮编：441200</div>
        </div>
        <div
          style="color: #626262;font-weight: 400;line-height: 30px;margin-right:66px;"
        >
          <div>版权所有：房县黄酒产业发展中心</div>
          <div>邮件：fxhjjzx@163.com</div>
          <div style="display: flex;">
            <img
              src="../assets/img/guohui.png"
              style="width: 25px;height: 27px;margin-right: 6px;"
            />
            <div>鄂ICP备202017862号</div>
          </div>
        </div>
        <div style="text-align:center;margin-right:70px;">
          <img src="@/assets/img/code.png" style="width:71px;height:71px;" />
          <div style="color:#404040;margin-top:5px;">房县黄酒网</div>
        </div>
        <div style="margin-right:40px;">
          <div style="color:#035AB1;font-weight:550">- 分享到 -</div>
          <div style="display:flex;">
            <img
              src="@/assets/img/wx.png"
              style="width:25px;height:25px;margin-right:10px;margin-top:10px"
            />
            <img
              src="@/assets/img/kj.png"
              style="width:25px;height:25px;margin-top:10px"
            />
          </div>
          <div style="display:flex;">
            <img
              src="@/assets/img/qq.png"
              style="width:25px;height:25px;margin-right:10px;margin-top:10px"
            />
            <img
              src="@/assets/img/wb.png"
              style="width:25px;height:25px;margin-top:10px"
            />
          </div>
        </div>
        <img src="../assets/img/sydw.png" style="width: 70px;height: 86px;" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data(){
        return {
            accessNum:0
        }
    },
    methods:{
        //获取平台访问量
        getAccess(){
            return new Promise((resolve, reject) => {
                this.$axios
                .post("fx-web/wine/access")
                .then((resp)=> {
                        if (resp.errcode == 0 || resp.errcode == "0") {
                            this.accessNum = resp.data[0].accessNum;
                        };
                        resolve();
                        },
            ()=> {
              resolve();
            }
          );
      });
    },
    },
    created(){
     this.getAccess();
    }
}
</script>
